import script from "./VideoGenerator.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoGenerator.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__